import template from './recapResponseFieldInstance.html';
import controller from './recapResponseFieldInstance.controller';

let fieldInstanceComponent = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    // fieldInstance: '<',
    fieldResponse: '<',
    // recapResponse: '<',
  }
};

export default fieldInstanceComponent;
